import { render, staticRenderFns } from "./PCreateForm.vue?vue&type=template&id=bcb161bc&scoped=true"
import script from "./PCreateForm.vue?vue&type=script&lang=js"
export * from "./PCreateForm.vue?vue&type=script&lang=js"
import style0 from "./PCreateForm.vue?vue&type=style&index=0&id=bcb161bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb161bc",
  null
  
)

export default component.exports